import { create } from 'zustand';
import { getSelectedCountryId, getCountryId, getUserRole } from "../utils/storage";

const getInitialCountryId = () => {
  const role = getUserRole();
  if (role === 1 || role === '1') {
    return getSelectedCountryId() || "";
  } else {
    return getCountryId() || "";
  }
};

const useCountryStore = create((set) => ({
  selectedCountryId: getInitialCountryId(),
  setSelectedCountryId: (id) => {
    const role = getUserRole();
    if (role === 1 || role === '1') {
      if (id) {
        localStorage.setItem("selectedCountryId", id);
      } else {
        localStorage.removeItem("selectedCountryId");
      }
      set({ selectedCountryId: id });
    }
  },
}));

export default useCountryStore;
